
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 48 48","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"24","cy":"24","r":"23.5","fill":"#fff","stroke":"#000"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M27.771 12.041a.74.74 0 01.49 0l5.24 1.835a.747.747 0 01.499.717c-.022 1.586-.508 7.064-5.682 9.38a.74.74 0 01-.604 0c-5.174-2.317-5.66-7.817-5.682-9.38a.747.747 0 01.499-.717l5.24-1.835zm-.498 1.758l-3.732 1.306c.119 1.67.76 5.024 3.732 6.937V13.8zm1.486 8.244v-8.244l3.732 1.306c-.118 1.679-.757 5.026-3.732 6.938zm-10.995-4.419a.478.478 0 00-.476.48v7.526h12.946c.226 0 .44.103.58.28l1.64 2.065a.755.755 0 01.051.073C33.569 29.77 32.336 32 30.319 32H16.577c-1.98 0-3.219-2.156-2.229-3.88a.724.724 0 01.046-.071l1.407-1.918v-8.027c0-1.09.88-1.975 1.963-1.975h1.957c.41 0 .743.335.743.748a.745.745 0 01-.743.747h-1.957zm-.844 9.5l-1.302 1.774c-.385.723.135 1.607.959 1.607h13.742c.839 0 1.356-.913.943-1.636l-1.386-1.744H16.92zm3.754 1.69c0-.412.333-.747.743-.747h4.062c.41 0 .743.335.743.748a.745.745 0 01-.743.747h-4.062a.745.745 0 01-.743-.747z","fill":"#202D38"}})])
          )
        }
      }
    